angular.module("vgresiduos").controller("CadriBalanceReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/saldo-cadri");
		};
	}
]);
